import cn from "classnames";
import { useTableContext } from "./TableContext";

interface Props {
  children: React.ReactNode;
  className?: string;
  selected?: boolean;
  onClick?: () => void;
  tabIndex?: number;
  role?: string;
  onKeyDown?: (e: React.KeyboardEvent<HTMLTableRowElement>) => void;
}

export function Row({ children, selected, className, onClick, tabIndex, role, onKeyDown }: Props) {
  const { hasHorizontalScroll } = useTableContext();

  function handleKeyDown(e: React.KeyboardEvent<HTMLTableRowElement>) {
    if (onKeyDown) {
      onKeyDown(e);
      return;
    }
    if (onClick && (e.key === "Enter" || e.key === " ")) {
      e.preventDefault();
      onClick();
    }
  }

  return (
    <tr
      onClick={onClick}
      tabIndex={tabIndex !== undefined ? tabIndex : onClick ? 0 : undefined}
      role={role !== undefined ? role : onClick ? "button" : undefined}
      onKeyDown={onClick || onKeyDown ? handleKeyDown : undefined}
      className={cn(
        "group border-b surface-container-stroke last:border-none",
        !selected && "hover:bg-grey-50",
        hasHorizontalScroll && "last:[&>td]:pb-6",
        className,
      )}>
      {children}
    </tr>
  );
}
